export default __webpack_public_path__ + "static/media/html5.aff8a9cb.svg";